import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { Box, Card, Tab, Tabs } from "@mui/material";
import a11yProps from "../../helpers/ay-props";
import React, { useEffect, useState } from "react";

import TabPanel from "../../helpers/TabPanel";
import ViewProjectReports from "./ViewProjectReports";
import ViewProgramReports from "./ViewProgramReports";
import ViewTaskReport from "./ViewTaskReport";
import TabBoxComponent from "components/UI/TabBox";

const TasksAndProjectsReportPage = ({
    location,
    SetSelectedMenu,
    selectedMenu,
    FetchDetails,
    resources,
    GetAllResources,
}) => {
    const [tabValue, setTabValue] = React.useState(0);
    const [employees, setEmployees] = useState([]);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };


    const addEmployees = () => {
        setEmployees(
            resources?.data?.map((v) => ({
                label: v.names,
                id: v.id,
                value: v.id,
            })) ?? []
        );
    };

    useEffect(() => {
        addEmployees();
    }, [resources?.data]);

    useEffect(() => {
        SetSelectedMenu({ ...selectedMenu, openSelect: true });
    }, [location?.state]);

    useEffect(() => {
        SetSelectedMenu({
            menu: "worklog",
            title: "Projects and Tasks Report",
        });
        GetAllResources();
    }, []);


    return (
        <Card>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>

                <TabBoxComponent
                    selectedValue={tabValue}
                    handleTabChange={handleChange}
                    tabList={[
                        {
                            label: "Task Report",
                            tabValue: 0,
                            permissionCode: "menu.report",
                        },
                        {
                            label: "Project Report",
                            tabValue: 1,
                            permissionCode: "menu.report",
                        },
                        // {
                        //     label: "Program Report",
                        //     tabValue: 2,
                        //     permissionCode: "menu.report",
                        // },
                    ]}
                />

                <TabPanel index={0} value={tabValue} p={0}>
                    <ViewTaskReport
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>
                <TabPanel index={1} value={tabValue} p={0}>
                    <ViewProjectReports
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>
                {/* <TabPanel index={2} value={tabValue} p={0}>
                    <ViewProgramReports
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel> */}

            </Box>
        </Card>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TasksAndProjectsReportPage);
